<template>
  <div class="resident-warpper">
    <div class="bg-white">
      <!--      <div class="flex align-center justify-between">-->
      <!--        <div class="flex-sub margin-right">-->
      <!--          <div class="flex align-center justify-between">-->
      <!--            <div class="flex align-center margin-right-sm margin-bottom-xs basis-sm">-->
      <!--              <span>姓<i style="padding-left: 14px;"></i>名：</span>-->
      <!--              <el-input v-model="name" placeholder="请输入姓名" class="flex-sub"></el-input>-->
      <!--            </div>-->
      <!--            <div class="flex align-center margin-right-sm margin-bottom-xs basis-sm">-->
      <!--              <span>手机号：</span>-->
      <!--              <el-input v-model="phone" placeholder="请输入手机号" class="flex-sub"></el-input>-->
      <!--            </div>-->
      <!--          </div>-->

      <!--          <fiveLevel @upFive="upFive"/>-->
      <!--        </div>-->
      <!--        <el-button type="primary" @click="hanldSearch">搜索</el-button>-->
      <!--      </div>-->

      <div class="flex align-center justify-between margin-bottom-sm">
        <div>
          <span style="font-size: 20px;color: #d70202">{{ name }}</span>的家庭成员，共<span
          style="font-size: 20px;color: #d70202">{{ total }}</span>人
        </div>
        <div>
        </div>
      </div>

      <el-table
        :data="residentList"
        header-row-class-name="table-header"
        row-class-name="table-row"
        alig="center"
        border
        style="width: 100%"
      >
        <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
        <!--        <el-table-column label="社区" prop="xiangmu_name"></el-table-column>-->
        <el-table-column label="小区" prop="xiaoqu_name"></el-table-column>
<!--        <el-table-column label="联系人" prop="guanjia_name"></el-table-column>-->
        <el-table-column label="居民姓名" prop="name"></el-table-column>
        <el-table-column label="手机号" prop="phone"></el-table-column>
        <el-table-column label="楼门户">
          <template slot-scope="scope">
            <div>
              {{ scope.row.building_name }}-{{ scope.row.element_name }}-{{ scope.row.room_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="关系" prop="link"></el-table-column>
        <el-table-column label="备注" prop="备注">
          <template slot-scope="scope">
            <div>
              <p>{{scope.row.beizhu}}</p>
              <p  v-if="scope.row.state === 2">拒绝原因：{{scope.row.beizhu}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="剩余积分" prop="integral"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="table-operate" v-if="scope.row.state === 0">
              <el-button
                size="small"
                type="primary"
                @click="passItem(scope.row.id)"
              >通过
              </el-button>
              <el-button
                size="small"
                type="primary"
                @click="refuseItem(scope.row.id)"
              >拒绝
              </el-button>

            </div>
            <div class="table-operate" v-else>
              <el-button
                v-if="scope.row.state === 1"
                size="small"
                type="success"  plain
              >已通过
              </el-button>
              <el-button
                v-if="scope.row.state === 2"
                size="small"
                type="primary"  plain
              >已驳回
              </el-button>
              <el-button
                size="small"
                type="primary"
                @click="delItem(scope.row.id)"
              >删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="residentList.length > 0"
        class="page-all"
        background
        @current-change="getResidentList"
        :current-page.sync="page"
        :page-size="limit"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>

import {delJiatingMember, exJiatingMember, getJiatingMember} from "@/api/weilao";

export default {
  name: "server-pople",
  data() {
    return {
      name: '',
      page: 1,
      limit: 10,
      total: 0,
      residentList: [],
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  created() {
    this.$emit("setIndex", '/home/team-member', "双暖为老 / 志愿者 / 家庭成员", true);
    this.name = this.$route.query.name
    this.getResidentList()
  },
  components: {},
  methods: {
    //  驳回通过
    refuseItem(id){
      this.$prompt('请输入驳回原因', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(({ value }) => {
        if(!value) return this.$message.error('请输入驳回原因')
        this.sureRefuse(id,2,value);
      });
    },
    async sureRefuse(id,state,str) {
      let _state = await exJiatingMember(id,state,str);
      this.getResidentList();
      this.$message.success(_state.info);
    },
    //  审核通过
    passItem(id){
      this.$confirm('您确定要通过该家庭成员吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.surePass(id,1,'');
      });
    },
    async surePass(id,state,str) {
      let _state = await exJiatingMember(id,state,str);
      this.getResidentList();
      this.$message.success(_state.info);
    },
    //  删除
    delItem(id){
      this.$confirm('您确定要删除该家庭成员吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      let _state = await delJiatingMember(id);
      this.getResidentList();
      this.$message.success(_state.info);
    },
    //  获取家庭成员列表
    async getResidentList() {
      let _data = await getJiatingMember(this.$route.params.id,)
      this.residentList = _data.data
      this.total = _data.total_number
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
